import React from 'react';
import { Search, Zap, Heart, MessageCircle } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function Solution() {
  const {
    t
  } = useLanguage();
  const bulletIcons = [<Search className="w-6 h-6 text-coral shrink-0 mt-1" data-id="element-143" />, <Zap className="w-6 h-6 text-coral shrink-0 mt-1" data-id="element-144" />, <Heart className="w-6 h-6 text-coral shrink-0 mt-1" data-id="element-145" />, <MessageCircle className="w-6 h-6 text-coral shrink-0 mt-1" data-id="element-146" />];
  return <section className="py-24 px-6 bg-ink text-cream" data-id="element-147">
      <div className="max-w-4xl mx-auto" data-id="element-148">
        <div className="text-center mb-20" data-id="element-149">
          <h2 className="font-serif text-4xl md:text-5xl mb-8" data-id="element-150">
            {t.solution.h2Part1}{' '}
            <span className="italic text-coral" data-id="element-151">{t.solution.h2Italic}</span>
          </h2>
          <p className="text-xl text-cream/80 max-w-2xl mx-auto" data-id="element-152">
            {t.solution.intro}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mb-20" data-id="element-153">
          {t.solution.bullets.map((bullet, idx) => <div key={idx} className="flex items-start gap-4 p-6 bg-white/5 rounded-2xl border border-white/10" data-id="element-154">
              {bulletIcons[idx]}
              <p className="text-lg" data-id="element-155">{bullet}</p>
            </div>)}
        </div>

        <div className="text-center mb-24" data-id="element-156">
          <p className="font-serif text-3xl italic mb-6" data-id="element-157">
            {t.solution.noOpinions}
          </p>
          <p className="text-xl text-coral font-medium" data-id="element-158">{t.solution.thisIs}</p>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-159">
          <h3 className="font-serif text-3xl mb-6" data-id="element-160">{t.solution.whatIsTitle}</h3>
          <div className="space-y-6 text-lg text-cream/80 mb-16" data-id="element-161">
            <p data-id="element-162">{t.solution.whatIs1}</p>
            <p data-id="element-163">{t.solution.whatIs2}</p>
            <p data-id="element-164">{t.solution.whatIs3}</p>
            <p data-id="element-165">{t.solution.whatIs4}</p>
          </div>

          <h3 className="font-serif text-3xl mb-8" data-id="element-166">{t.solution.howTitle}</h3>
          <div className="space-y-4 mb-12" data-id="element-167">
            {t.solution.steps.map((step, index) => <div key={index} className="flex items-center gap-6 p-4 border-b border-white/10" data-id="element-168">
                <span className="font-serif text-2xl text-coral/50" data-id="element-169">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <p className="text-lg" data-id="element-170">{step}</p>
              </div>)}
          </div>

          <p className="text-center text-xl font-serif italic text-coral mb-16" data-id="element-171">
            {t.solution.totalTime}
          </p>

          <div className="p-8 bg-white/5 rounded-2xl border border-white/10 text-center space-y-4" data-id="element-172">
            <p className="text-lg text-cream/80" data-id="element-173">{t.solution.disclaimer1}</p>
            <p className="text-lg text-cream/80" data-id="element-174">{t.solution.disclaimer2}</p>
            <p className="text-lg text-cream/80" data-id="element-175">{t.solution.disclaimer3}</p>
            <p className="text-xl font-medium pt-4" data-id="element-176">{t.solution.disclaimer4}</p>
          </div>
        </div>
      </div>
    </section>;
}